import { render, staticRenderFns } from "./appoint-unit.vue?vue&type=template&id=ac8d2254&scoped=true&"
import script from "./appoint-unit.vue?vue&type=script&lang=js&"
export * from "./appoint-unit.vue?vue&type=script&lang=js&"
import style0 from "./appoint-unit.vue?vue&type=style&index=0&id=ac8d2254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8d2254",
  null
  
)

export default component.exports